import { useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "@/components/ui/sonner";
import "@/App.css";
import { Navbar } from "@/components/Navbar";
import { Hero } from "@/components/Hero";
import { Marquee } from "@/components/Marquee";
import { ChristSection } from "@/components/ChristSection";
import { SchedeChrist } from "@/components/SchedeChrist";
import { OfficinaSection } from "@/components/OfficinaSection";
import { Services } from "@/components/Services";
import { Clienti } from "@/components/Clienti";
import { Marchi } from "@/components/MarchiSection";
import { ChiSiamo } from "@/components/ChiSiamo";
import { Gallery } from "@/components/Gallery";
import { Assistenza } from "@/components/Assistenza";
import { Contatti } from "@/components/Contatti";
import { Faq } from "@/components/Faq";
import { Footer } from "@/components/Footer";
import { ChatWidget } from "@/components/ChatWidget";
import AdminPage from "@/pages/AdminPage";
import ProjectPage from "./pages/ProjectPage";
import LegalPage from "@/pages/LegalPage";
import LegacyRedirect from "@/pages/LegacyRedirect";
import AdminResetPage from "@/pages/AdminResetPage";
import { CookieBanner } from "@/components/CookieBanner";
import { useSeo, SEO } from "@/lib/seo";
import { scrollToSection } from "@/lib/scroll";

function HomePage() {
    useSeo(SEO.home);
    useEffect(() => {
        const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
        window.__lenis = lenis;
        let rafId;
        const raf = (time) => {
            lenis.raf(time);
            rafId = requestAnimationFrame(raf);
        };
        rafId = requestAnimationFrame(raf);
        const target = window.location.hash.replace("#", "");
        if (target) setTimeout(() => scrollToSection(target), 400);
        return () => {
            cancelAnimationFrame(rafId);
            lenis.destroy();
            window.__lenis = null;
        };
    }, []);

    return (
        <div className="min-h-screen bg-white">
            <Navbar />
            <main>
                <Hero />
                <Marquee />
                <ChristSection />
                <SchedeChrist />
                <OfficinaSection />
                <Services />
                <Clienti />
                <Marchi />
                <ChiSiamo />
                <Gallery />
                <Assistenza />
                <Contatti />
                <Faq />
            </main>
            <Footer />
            <ChatWidget />
        </div>
    );
}

function App() {
    return (
        <BrowserRouter>
            <Routes>
                <Route path="/" element={<HomePage />} />
                <Route path="/realizzazioni/:slug" element={<ProjectPage />} />
                <Route path="/admin" element={<AdminPage />} />
                <Route path="/admin/reset" element={<AdminResetPage />} />
                <Route path="/privacy-policy" element={<LegalPage />} />
                <Route path="/cookie-policy" element={<LegalPage />} />
                <Route path="*" element={<LegacyRedirect />} />
            </Routes>
            <CookieBanner />
            <Toaster position="top-center" richColors closeButton />
        </BrowserRouter>
    );
}

export default App;
